// react library imports
import { lazy } from 'react';

// Layout imports
const ResourceLayout = lazy(()=>import('Layout/Resource'))

// resource pages imports
const RegisterPreschool = lazy(()=>import('Pages/Network/RegisterPreschool/RegisterPreschool'))
const NearByPreschool = lazy(()=>import('Pages/Network/NearByPreschool/NearByPreschool'))
const ParentsGuide = lazy(()=>import('Pages/Network/ParentGuide/ParentGuide'))
const ConsultantGuide = lazy(()=>import('Pages/Network/ConsultantGuide/ConsultantGuide'))

export const NetworkRoutes = [
    {
      path: "mues-network",
      element: <ResourceLayout />,
      children: [
        { path: "register-preschool", element: <RegisterPreschool /> },
        { path : "preschool_near_me", element: <NearByPreschool /> },
        { path : "parent-guide", element: <ParentsGuide /> },
        { path : "consultant-guide", element: <ConsultantGuide /> },
      ],
    },
];